require('./bootstrap');

require('../../lib/Genie/DomElements/resources/js/import.js');
require('../../lib/Genie/Gallery/resources/js/import.js');

